// import React, { useEffect, useState } from "react";
// import "../Cart/Cart.css";
// import { Row, Col } from "react-bootstrap";
// import arrowback from "../../assets/images/png/arrow_back.png";
// import lock from "../../assets/images/png/lock.png";
// import message from "../../assets/images/png/message.png";
// import delivery from "../../assets/images/png/deliveryicon.png";

// import { Link, useNavigate } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import {
//   addProducttoWishlist,
//   getWishlistProducts,
// } from "../../services/WishlistServices";
// const CartDetails = ({
//   cartProduct,
//   updateQuantity,
//   removeAllProduct,
//   removeProduct,
// }) => {
//   const [favouriteItems, setFavouriteItems] = useState([]);
//   const navigate = useNavigate();
//   const tokenitem = localStorage.getItem("token");

//   const getWishlistItems = async () => {
//     const res = await getWishlistProducts(tokenitem);
//     setFavouriteItems(res);
//   };
//   const addToWishlist = async (id) => {
//     if (tokenitem) {
//       const productId = id;
//       await addProducttoWishlist(productId, tokenitem);
//       getWishlistItems();
//     } else {
//       localStorage.setItem("path", "/farmer-shop");
//       navigate("/signin");
//     }
//   };

//   const isInWishlist = (id) => {
//     return (
//       favouriteItems &&
//       favouriteItems.some((item) => item?.productId?._id === id)
//     );
//   };

//   useEffect(() => {
//     getWishlistItems();
//   }, []);

//   return (
//     <div className="bg_clr_light_yellow">
//       <ToastContainer />
//       <div className="">
//         <h2 className="ff_heebo fw-bold fs_7xl clr_dark_blue_2 mb-3">
//           My cart{" "}
//           <span className="clr_dark_green fs_lg">
//             {cartProduct && cartProduct.length !== 0 ? (
//               <> ({cartProduct && cartProduct.length})</>
//             ) : (
//               <>(0)</>
//             )}
//           </span>
//         </h2>
//         <Row className="">
//           <Col>
//             <div className="bg-white px-4 pb-4 rounded-2 bg-white-border">
//               {cartProduct && cartProduct.length !== 0 ? (
//                 cartProduct?.map((value, index) => (
//                   <Row key={index} className="border-bottom-row px-2 pb-3 mt-4">
//                     <Col className="ps-0" md={8} sm={12}>
//                       <Row className="align-items-start height-of-products">
//                         <Col lg={5} xl={3} md={4} sm={5}>
//                           <Link
//                             to={`/product-details/${value?.productId?._id}`}
//                           >
//                             <div className="border-1 border rounded-2 text-center p-1 cursor-pointer">
//                               <img
//                                 style={{ width: "100px", height: "120px" }}
//                                 className=" object-fit-contain py-3"
//                                 src={value?.productId?.images?.[0]}
//                                 alt="productimage"
//                               />
//                             </div>
//                           </Link>
//                         </Col>
//                         <Col
//                           className="ps-sm-0 mt-3 mt-sm-0 d-flex flex-column justify-content-between h-100"
//                           lg={7}
//                           xl={9}
//                           md={8}
//                           sm={7}
//                         >
//                           <div>
//                             <p className="clr_dark_blue_2 fs_md fw-medium ff_heebo mb-0 text-capitalize">
//                               {value?.productId?.name}
//                             </p>
//                             {value?.productId?.productType === "machinery" ? (
//                               <p className="clr_dark_grey_5 fs_xsmff_heebo mb-0">
//                                 Size: medium, Color: blue, Material: Plastic
//                               </p>
//                             ) : (
//                               ""
//                             )}

//                             <p className="clr_dark_grey_5 fs_xsmff_heebo mb-0">
//                               Seller: {value?.productId?.sellerType}
//                             </p>
//                             <div className="d-flex align-items-center gap-3 mt-2">
//                               <button
//                                 onClick={() =>
//                                   removeProduct(value?.productId?._id)
//                                 }
//                                 className="btn-common-remove-save ff_heebo color_red_2 ff_inter fs_4xsm bg-white py-1 px-2"
//                               >
//                                 Remove
//                               </button>
//                               {isInWishlist(value?.productId?._id) ? (
//                                 <button
//                                   onClick={() =>
//                                     addToWishlist(value?.productId?._id)
//                                   }
//                                   className="btn-common-remove-save ff_heebo clr_dark_green ff_inter fs_4xsm bg-white py-1 px-2"
//                                 >
//                                   Remove from wishlist
//                                 </button>
//                               ) : (
//                                 <button
//                                   onClick={() =>
//                                     addToWishlist(value?.productId?._id)
//                                   }
//                                   className="btn-common-remove-save ff_heebo clr_dark_green ff_inter fs_4xsm bg-white py-1 px-2"
//                                 >
//                                   Save for later
//                                 </button>
//                               )}
//                             </div>
//                           </div>
//                           <div className="d-md-none flex-column-reverse d-flex gap-1 mt-3">
//                             <div className="d-flex align-items-center gap-3">
//                               <p className="ff_heebo fw-medium text-start fs_xxsm clr_dark_blue_2 mb-0">
//                                 <span className="fw-bold">₹</span>
//                                 {value?.productId?.discountPrice *
//                                   value?.quantity}
//                               </p>
//                               <div className="me-auto ms-0 d-flex align-items-center select-div px-2 rounded-2">
//                                 <button
//                                   onClick={() =>
//                                     updateQuantity(
//                                       value?.productId?._id,
//                                       value?.quantity - 1
//                                     )
//                                   }
//                                   className="bg-transparent border-0 ff_hebbo pb-1"
//                                 >
//                                   -
//                                 </button>
//                                 <div className="ps-1">
//                                   <p className="mb-0 clr_dark_blue_2 ff_heebo">
//                                     Qty:
//                                   </p>
//                                 </div>
//                                 <input
//                                   class="select-option me-auto ps-1 ms-0 clr_dark_blue_2 ff_heebo"
//                                   value={value?.quantity}
//                                   onChange={(e) =>
//                                     updateQuantity(
//                                       value?.productId?._id,
//                                       e.target.value
//                                     )
//                                   }
//                                 />
//                                 <button
//                                   onClick={() =>
//                                     updateQuantity(
//                                       value?.productId?._id,
//                                       value?.quantity + 1
//                                     )
//                                   }
//                                   className="bg-transparent border-0 ff_hebbo pb-1"
//                                 >
//                                   +
//                                 </button>
//                               </div>
//                             </div>
//                           </div>
//                         </Col>
//                       </Row>
//                     </Col>
//                     <Col className="pe-0 d-none d-md-block" md={4} sm={5}>
//                       <div>
//                         <p className="ff_heebo fw-medium text-end fs_xxsm clr_dark_blue_2 mb-1">
//                           <span className="fw-bold">₹</span>
//                           {value?.productId?.discountPrice * value?.quantity}
//                         </p>
//                         <div className="w-50 ms-auto d-flex align-items-center select-div px-2 rounded-2">
//                           <button
//                             onClick={() =>
//                               updateQuantity(
//                                 value?.productId?._id,
//                                 value?.quantity - 1
//                               )
//                             }
//                             className="bg-transparent border-0 ff_hebbo pb-1"
//                           >
//                             -
//                           </button>
//                           <div className="ps-1">
//                             <p className="mb-0 clr_dark_blue_2 ff_heebo">
//                               Qty:
//                             </p>
//                           </div>
//                           <input
//                             class="select-option me-auto ps-1 ms-0 clr_dark_blue_2 ff_heebo w-100"
//                             value={value?.quantity}
//                             onChange={(e) =>
//                               updateQuantity(
//                                 value?.productId?._id,
//                                 e.target.value
//                               )
//                             }
//                           />
//                           <button
//                             onClick={() =>
//                               updateQuantity(
//                                 value?.productId?._id,
//                                 value?.quantity + 1
//                               )
//                             }
//                             className="bg-transparent border-0 ff_hebbo pb-1"
//                           >
//                             +
//                           </button>
//                         </div>
//                       </div>
//                     </Col>
//                   </Row>
//                 ))
//               ) : (
//                 <div className="py-5">
//                   <h2 className="text-center">Empty Cart</h2>
//                   <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-sm-5 gap-1">
//                     <button
//                       onClick={() => navigate("/farmer-shop")}
//                       className="d-flex align-items-center gap-2 justify-content-center mt-3 btn-common-remove-save py-2 px-3"
//                     >
//                       <img
//                         style={{ width: "18px", height1: "18px" }}
//                         src={arrowback}
//                         alt="backarrow"
//                       />
//                       <p className="mb-0 clr_dark_green fw-medium">
//                         Add Products
//                       </p>
//                     </button>
//                   </div>
//                 </div>
//               )}

//               <div className="d-flex align-items-center justify-content-between mt-4">
//                 <div
//                   onClick={() => navigate("/farmer-shop")}
//                   className="d-flex align-items-center gap-2 cursor-pointer"
//                 >
//                   <img
//                     style={{ width: "18px", height1: "18px" }}
//                     src={arrowback}
//                     alt="backarrow"
//                   />
//                   <p className="mb-0 clr_dark_green fw-medium">Back to shop</p>
//                 </div>
//                 <div>
//                   <button
//                     style={{ height: "39px", paddingBottom: "2px" }}
//                     onClick={removeAllProduct}
//                     className="ff_inter fs_xxsm clr_dark_green btn-common-remove-save px-3 bg-white fw-medium"
//                   >
//                     Remove all
//                   </button>
//                 </div>
//               </div>
//             </div>
//             <div className="my-3">
//               <Row className="justify-content-center">
//                 <Col lg={4} sm={6}>
//                   <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
//                     <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
//                       <img
//                         style={{ width: "15px", height: "20px" }}
//                         src={lock}
//                         alt="lock"
//                       />
//                     </div>
//                     <div>
//                       <p className="ff_inter fs_xxsm clr_dark_blue_2 mb-0">
//                         Secure payment
//                       </p>
//                       <p className="ff_inter fs_xxsm color_grey_4 mb-0">
//                         Have you ever finally just{" "}
//                       </p>
//                     </div>
//                   </div>
//                 </Col>
//                 <Col className="mt-3 mt-sm-0" lg={4} sm={6}>
//                   <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
//                     <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
//                       <img
//                         style={{ width: "19px", height: "19px" }}
//                         src={message}
//                         alt="lock"
//                       />
//                     </div>
//                     <div>
//                       <p className="ff_inter fs_xxsm clr_dark_blue_2 mb-0">
//                         Secure payment
//                       </p>
//                       <p className="ff_inter fs_xxsm color_grey_4 mb-0">
//                         Have you ever finally just{" "}
//                       </p>
//                     </div>
//                   </div>
//                 </Col>
//                 <Col className="mt-3 mt-lg-0" lg={4} sm={6}>
//                   <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
//                     <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
//                       <img
//                         style={{ width: "21px", height: "15px" }}
//                         src={delivery}
//                         alt="lock"
//                       />
//                     </div>
//                     <div>
//                       <p className="ff_inter fs_xxsm clr_dark_blue_2 mb-0">
//                         Secure payment
//                       </p>
//                       <p className="ff_inter fs_xxsm color_grey_4 mb-0">
//                         Have you ever finally just{" "}
//                       </p>
//                     </div>
//                   </div>
//                 </Col>
//               </Row>
//             </div>
//           </Col>
//         </Row>
//       </div>
//     </div>
//   );
// };

// export default CartDetails;

import React, { useEffect, useState } from "react";
import "../Cart/Cart.css";
import { Row, Col } from "react-bootstrap";
import arrowback from "../../assets/images/png/arrow_back.png";
import lock from "../../assets/images/png/lock.png";
import message from "../../assets/images/png/message.png";
import delivery from "../../assets/images/png/deliveryicon.png";

import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  addProducttoWishlist,
  getWishlistProducts,
} from "../../services/WishlistServices";

const CartDetails = ({
  cartProduct,
  updateQuantity,
  removeAllProduct,
  removeProduct,
}) => {
  const [favouriteItems, setFavouriteItems] = useState([]);
  const navigate = useNavigate();
  const tokenitem = localStorage.getItem("token");

  const getWishlistItems = async () => {
    const res = await getWishlistProducts(tokenitem);
    setFavouriteItems(res);
  };

  const addToWishlist = async (id) => {
    if (tokenitem) {
      const productId = id;
      await addProducttoWishlist(productId, tokenitem);
      getWishlistItems();
    } else {
      localStorage.setItem("path", "/farmer-shop");
      navigate("/signin");
    }
  };

  const isInWishlist = (id) => {
    return (
      favouriteItems &&
      favouriteItems.some((item) => item?.productId?._id === id)
    );
  };

  useEffect(() => {
    getWishlistItems();
  }, []);

  return (
    <div className="bg_clr_light_yellow">
      <ToastContainer />
      <div className="">
        <h2 className="ff_heebo fw-bold fs_7xl clr_dark_blue_2 mb-3">
          My cart{" "}
          <span className="clr_dark_green fs_lg">
            {cartProduct && cartProduct.length !== 0 ? (
              <> ({cartProduct && cartProduct.length})</>
            ) : (
              <>(0)</>
            )}
          </span>
        </h2>
        <Row className="">
          <Col>
            <div className="bg-white px-4 pb-4 rounded-2 bg-white-border">
              {cartProduct && cartProduct.length !== 0 ? (
                cartProduct?.map((value, index) => (
                  <Row key={index} className="border-bottom-row px-2 pb-3 mt-4">
                    <Col className="ps-0" md={8} sm={12}>
                      <Row className="align-items-start height-of-products">
                        <Col lg={5} xl={3} md={4} sm={5}>
                          <Link
                            to={`/product-details/${value?.productId?._id}`}
                          >
                            <div className="border-1 border rounded-2 text-center p-1 cursor-pointer">
                              {value?.productId?.images?.[0] ? (
                                <img
                                  style={{ width: "100px", height: "120px" }}
                                  className=" object-fit-contain py-3"
                                  src={value?.productId?.images?.[0]}
                                  alt="productimage"
                                />
                              ) : (
                                <img
                                  style={{ width: "100px", height: "120px" }}
                                  className=" object-fit-contain py-3"
                                  src={
                                    "https://savr-dev-bucket.s3.amazonaws.com/83b1a7b1-728b-4f45-9615-1b7b86b572b4"
                                  }
                                  alt="productimage"
                                />
                              )}
                            </div>
                          </Link>
                        </Col>
                        <Col
                          className="ps-sm-0 mt-3 mt-sm-0 d-flex flex-column justify-content-between h-100"
                          lg={7}
                          xl={9}
                          md={8}
                          sm={7}
                        >
                          <div>
                            <p className="clr_dark_blue_2 fs_md fw-medium ff_heebo mb-0 text-capitalize">
                              {value?.productId?.name}
                            </p>
                            {value?.productId?.productType === "machinery" ? (
                              <p className="clr_dark_grey_5 fs_xsmff_heebo mb-0">
                                Size: medium, Color: blue, Material: Plastic
                              </p>
                            ) : (
                              ""
                            )}

                            <p className="clr_dark_grey_5 fs_xsmff_heebo mb-0">
                              Seller: {value?.productId?.sellerType}
                            </p>
                            <div className="d-flex align-items-center gap-3 mt-2">
                              <button
                                onClick={() =>
                                  removeProduct(value?.productId?._id)
                                }
                                className="btn-common-remove-save ff_heebo color_red_2 ff_inter fs_4xsm bg-white py-1 px-2"
                              >
                                Remove
                              </button>
                              {isInWishlist(value?.productId?._id) ? (
                                <button
                                  onClick={() =>
                                    addToWishlist(value?.productId?._id)
                                  }
                                  className="btn-common-remove-save ff_heebo clr_dark_green ff_inter fs_4xsm bg-white py-1 px-2"
                                >
                                  Remove from wishlist
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    addToWishlist(value?.productId?._id)
                                  }
                                  className="btn-common-remove-save ff_heebo clr_dark_green ff_inter fs_4xsm bg-white py-1 px-2"
                                >
                                  Save for later
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="d-md-none flex-column-reverse d-flex gap-1 mt-3">
                            <div className="d-flex align-items-center gap-3">
                              <p className="ff_heebo fw-medium text-start fs_xxsm clr_dark_blue_2 mb-0">
                                <span className="fw-bold">₹</span>
                                {value?.productId?.discountPrice *
                                  value?.quantity}
                              </p>
                              <div className="me-auto ms-0 d-flex align-items-center select-div px-2 rounded-2">
                                <button
                                  onClick={() =>
                                    updateQuantity(
                                      value?.productId?._id,
                                      value?.quantity - 1
                                    )
                                  }
                                  className="bg-transparent border-0 ff_hebbo pb-1"
                                >
                                  -
                                </button>
                                <div className="ps-1">
                                  <p className="mb-0 clr_dark_blue_2 ff_heebo">
                                    Qty:
                                  </p>
                                </div>
                                <input
                                  className="select-option me-auto ps-1 ms-0 clr_dark_blue_2 ff_heebo"
                                  value={value?.quantity}
                                  onChange={(e) => {
                                    const quantity = Math.max(
                                      1,
                                      e.target.value
                                    );
                                    updateQuantity(
                                      value?.productId?._id,
                                      quantity
                                    );
                                  }}
                                />
                                <button
                                  onClick={() =>
                                    updateQuantity(
                                      value?.productId?._id,
                                      value?.quantity + 1
                                    )
                                  }
                                  className="bg-transparent border-0 ff_hebbo pb-1"
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="pe-0 d-none d-md-block" md={4} sm={5}>
                      <div>
                        <p className="ff_heebo fw-medium text-end fs_xxsm clr_dark_blue_2 mb-1">
                          <span className="fw-bold">₹</span>
                          {value?.productId?.discountPrice * value?.quantity}
                        </p>
                        <div className="w-50 ms-auto d-flex align-items-center select-div px-2 rounded-2">
                          <button
                            onClick={() =>
                              updateQuantity(
                                value?.productId?._id,
                                value?.quantity - 1
                              )
                            }
                            className="bg-transparent border-0 ff_hebbo pb-1"
                          >
                            -
                          </button>
                          <div className="ps-1">
                            <p className="mb-0 clr_dark_blue_2 ff_heebo">
                              Qty:
                            </p>
                          </div>
                          <input
                            className="select-option me-auto ps-1 ms-0 clr_dark_blue_2 ff_heebo w-100"
                            value={value?.quantity}
                            onChange={(e) => {
                              const quantity = Math.max(1, e.target.value);
                              updateQuantity(value?.productId?._id, quantity);
                            }}
                          />
                          <button
                            onClick={() =>
                              updateQuantity(
                                value?.productId?._id,
                                value?.quantity + 1
                              )
                            }
                            className="bg-transparent border-0 ff_hebbo pb-1"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                ))
              ) : (
                <div className="py-5">
                  <h2 className="text-center">Empty Cart</h2>
                  <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-sm-5 gap-1">
                    <button
                      onClick={() => navigate("/farmer-shop")}
                      className="d-flex align-items-center gap-2 justify-content-center mt-3 btn-common-remove-save py-2 px-3"
                    >
                      <img
                        style={{ width: "18px", height1: "18px" }}
                        src={arrowback}
                        alt="backarrow"
                      />
                      <p className="mb-0 clr_dark_green fw-medium">
                        Add Products
                      </p>
                    </button>
                  </div>
                </div>
              )}

              <div className="d-flex align-items-center justify-content-between mt-4">
                <div
                  onClick={() => navigate("/farmer-shop")}
                  className="d-flex align-items-center gap-2 cursor-pointer"
                >
                  <img
                    style={{ width: "18px", height1: "18px" }}
                    src={arrowback}
                    alt="backarrow"
                  />
                  <p className="mb-0 clr_dark_green fw-medium">Back to shop</p>
                </div>
                <div>
                  <button
                    style={{ height: "39px", paddingBottom: "2px" }}
                    onClick={removeAllProduct}
                    className="ff_inter fs_xxsm clr_dark_green btn-common-remove-save px-3 bg-white fw-medium"
                  >
                    Remove all
                  </button>
                </div>
              </div>
            </div>
            <div className="my-3">
              <Row className="justify-content-center">
                <Col lg={4} sm={6}>
                  <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
                    <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
                      <img
                        style={{ width: "15px", height: "20px" }}
                        src={lock}
                        alt="lock"
                      />
                    </div>
                    <div>
                      <p className="ff_inter fs_xxsm clr_dark_blue_2 mb-0">
                        Secure payment
                      </p>
                      <p className="ff_inter fs_xxsm color_grey_4 mb-0">
                        Have you ever finally just{" "}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="mt-3 mt-sm-0" lg={4} sm={6}>
                  <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
                    <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
                      <img
                        style={{ width: "19px", height: "19px" }}
                        src={message}
                        alt="lock"
                      />
                    </div>
                    <div>
                      <p className="ff_inter fs_xxsm clr_dark_blue_2 mb-0">
                        Secure payment
                      </p>
                      <p className="ff_inter fs_xxsm color_grey_4 mb-0">
                        Have you ever finally just{" "}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="mt-3 mt-lg-0" lg={4} sm={6}>
                  <div className="d-flex align-items-center gap-3 bg-white secure-customer-delivery-common rounded-2">
                    <div className="bg_clr_light_yellow lock-bg-div d-flex align-items-center justify-content-center">
                      <img
                        style={{ width: "21px", height: "15px" }}
                        src={delivery}
                        alt="lock"
                      />
                    </div>
                    <div>
                      <p className="ff_inter fs_xxsm clr_dark_blue_2 mb-0">
                        Secure payment
                      </p>
                      <p className="ff_inter fs_xxsm color_grey_4 mb-0">
                        Have you ever finally just{" "}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CartDetails;
